import Yup from 'utils/validation';

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

const daysOfWeek = ['0', '1', '2', '3', '4', '5', '6'];

export const timeSlotSchema = Yup.object({
  start: Yup.string()
    .matches(timeRegex, 'Time must be in HH:mm format')
    .required(),
  end: Yup.string()
    .matches(timeRegex, 'Time must be in HH:mm format')
    .required()
});

export const availabilitySchema = Yup.object().shape(
  daysOfWeek.reduce(
    (acc, day) => ({
      ...acc,
      [day]: Yup.array().of(timeSlotSchema)
    }),
    {}
  )
);
